import "../../../assets/styles/containers/_commentLibraryModal.scss";

const CommentTags = ({ tags, selectedFilterTagID }) => {
    const filteredTags = tags?.filter(tag => {
        const tagId = tag?.tag?.id || tag?.id;
        return !selectedFilterTagID?.includes(tagId);
    });

    const getTextColor = (bgColor) => {
        const luminance = getLuminance(bgColor);
        return luminance > 0.179 ? "#000000" : "#ffffff";
    };

    function getLuminance(hexColor) {
        const r = parseInt(hexColor.substr(1, 2), 16);
        const g = parseInt(hexColor.substr(3, 2), 16);
        const b = parseInt(hexColor.substr(5, 2), 16);
        const Y = (r * 299 + g * 587 + b * 114) / 1000;
        return Y <= 0.03928 ? Y / 12.92 : ((Y + 0.055) / 1.055) ** 2.4;
    }

    return (
        <div className="comment_tags_container">
            {filteredTags?.map((tag, index) => (
                <div
                    key={index}
                    className="comment_tag"
                    style={{
                        backgroundColor: tag?.color || tag?.tag?.color,
                        color: getTextColor("#000000"),
                    }}
                >
                    {tag?.name || tag?.tag?.name}
                </div>
            ))}
        </div>
    );
};

export default CommentTags;